import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { passengerTypes, passengerActions } = createActionsStructure('passenger', [
  { name: 'SET_PASSENGER', async: true },
  { name: 'SET_PASSENGER_BOOKING', async: true },
  { name: 'GET_PASSENGER', async: true },
  { name: 'GET_PASSENGER_BOOKINGS', async: true },
  { name: 'CHECK_PASSENGER_BOOKINGS', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/PassengerActions.js